'use client'

import {Swiper, SwiperSlide} from "swiper/react";
import {Autoplay, Navigation, Pagination, Scrollbar} from 'swiper/modules';
import 'swiper/scss';
import 'swiper/scss/navigation';
import 'swiper/scss/pagination';
import './slider.scss';
import SwiperCore from 'swiper';
import {ButtonArrowIcon} from "@/app/[locale]/common/assets/ButtonArrowIcon/ButtonArrowIcon";
import {
    MAIN_SLIDER_BREAKPOINT_RESPONSIVE_IMAGES,
    MAIN_SLIDER_CONTENT, SLIDER_TITLE_EN,
} from "../../constants/slider";
import {TSliderContent} from "@/app/[locale]/common/components/MainSlider/types";
import Image from "next/image";
import {useResponsive} from "@/app/[locale]/common/utils/hooks/useResponsive/useResponsive";

SwiperCore.use([Navigation, Pagination, Autoplay, Scrollbar]);

export const MainSlider = () => {
    const imageVersion = useResponsive(MAIN_SLIDER_BREAKPOINT_RESPONSIVE_IMAGES.DESKTOP_FLAG, MAIN_SLIDER_BREAKPOINT_RESPONSIVE_IMAGES.MOBILE_FLAG, MAIN_SLIDER_BREAKPOINT_RESPONSIVE_IMAGES.BREAKPOINT);

    return (
        <div className={'slider'}>
            <Swiper
                slidesPerView={1}
                pagination={{
                    el: '.custom-pagination',
                    clickable: true,
                    renderBullet: (index, className) => (
                        `<span class="${className} custom-bullet">
                            <span class="click-area"></span>
                         </span>`
                    ),
                }}
                navigation={{
                    nextEl: '.custom-next',
                    prevEl: '.custom-prev',
                }}
                loop={true}
                autoplay={{
                    delay: 5000,
                }}
                speed={800}
            >
                {
                    MAIN_SLIDER_CONTENT.map((item: TSliderContent, index: number) => (
                        <SwiperSlide key={index} className={'main-slider-swiper'}>
                            {
                                imageVersion === 'desktop' ?
                                    <div className={'main-slider-swiper_imageContainer'}>
                                        <Image src={item.image.src} width={1920} height={1080}
                                               alt={'Slide desktop Image' + index}/>
                                    </div>
                                    :
                                    <div className={'main-slider-swiper_imageContainer'}>
                                        <Image src={item.mobImage.src} width={375} height={500}
                                               alt={'Slide mobil Image' + index}/>
                                    </div>
                            }
                        </SwiperSlide>
                    ))
                }
            </Swiper>
            <div className={'slider-container'}>
                <p className={'slider_title'}>{SLIDER_TITLE_EN.BEFORE} <span>{SLIDER_TITLE_EN.HIGHLIGHT}</span></p>
                <div className={'custom-pagination'}></div>
                <div className={'navigation-buttons'}>
                    <button className={'custom-prev'}><ButtonArrowIcon/></button>
                    <button className={'custom-next'}><ButtonArrowIcon/></button>
                </div>
            </div>
        </div>
    );
};